import { ExpectedError } from '@/utils/error-reporting';

import type { RumErrorEventDomainContext, RumInitConfiguration } from '@datadog/browser-rum-slim';

const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

export const getDatadogRumInitConfiguration = (): RumInitConfiguration | undefined => {
  if (!applicationId || !clientToken) {
    return;
  }

  return {
    applicationId,
    beforeSend: (event, context) => !(event.type === 'error' && (context as RumErrorEventDomainContext).error instanceof ExpectedError),
    clientToken,
    defaultPrivacyLevel: 'mask-user-input',
    env: process.env.NEXT_PUBLIC_DATADOG_ENV ?? process.env.NODE_ENV,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE ?? 'landings-payload-cms',
    sessionReplaySampleRate: 0,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE ?? 'datadoghq.com',
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
  };
};
